{
  "about.blocks": "Sirvidores moderados",
  "about.contact": "Kontakto:",
  "about.default_locale": "Predeterminado",
  "about.disclaimer": "Mastodon es un programario libero, kon kodiche avierto i una marka komersiala de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Razon no desponivle",
  "about.domain_blocks.preamble": "Mastodon djeneralmente te permete ver kontenido de i enteraktuar kon utilizadores de kualseker otro sirvidor en el fediverso. Estas son las eksepsiones en este sirvidor en partikolar.",
  "about.domain_blocks.silenced.explanation": "Djeneralmente no veras profiles i kontenido de este sirvidor, salvo ke eksplisitamente lo bushkes o sigas algun kuento de el.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Dingunos datos de este sirvidor seran prosesados, magazinados o enterkambiados. Enteraksyon o komunikasyon kon sus utilizadores sera imposivle.",
  "about.domain_blocks.suspended.title": "Suspendido",
  "about.language_label": "Lingua",
  "about.not_available": "Esta enformasyon no esta desponivle en este sirvidor.",
  "about.powered_by": "Redes sosyalas desentralizadas kon uzo de {mastodon}",
  "about.rules": "Reglas del sirvidor",
  "account.account_note_header": "Nota personala",
  "account.add_or_remove_from_list": "Adjusta a o kita de listas",
  "account.badges.bot": "Otomatizado",
  "account.badges.group": "Grupo",
  "account.block": "Bloka @{name}",
  "account.block_domain": "Bloka el domeno {domain}",
  "account.block_short": "Bloka",
  "account.blocked": "Blokado",
  "account.cancel_follow_request": "Anula solisitud de segir",
  "account.copy": "Kopia atadijo de profil",
  "account.direct": "Enmenta a @{name} en privado",
  "account.disable_notifications": "Desha de avizarme sovre publikasyones de @{name}",
  "account.edit_profile": "Edita profil",
  "account.edit_profile_short": "Edita",
  "account.enable_notifications": "Avizame kuando @{name} publike",
  "account.endorse": "Avalia en profil",
  "account.familiar_followers_one": "Segido por {name1}",
  "account.familiar_followers_two": "Segido por {name1} i {name2}",
  "account.featured": "Avaliado",
  "account.featured.accounts": "Profiles",
  "account.follow": "Sige",
  "account.follow_back": "Sige tamyen",
  "account.follow_back_short": "Sige tambyen",
  "account.follow_request": "Solisita segirle",
  "account.follow_request_cancel": "Anula solisitud",
  "account.follow_request_cancel_short": "Anula",
  "account.follow_request_short": "Solisitud",
  "account.followers": "Suivantes",
  "account.followers.empty": "Por agora dingun no sige a este utilizador.",
  "account.followers_counter": "{count, plural, one {{counter} suivante} other {{counter} suivantes}}",
  "account.followers_you_know_counter": "{counter} ke koneses",
  "account.following": "Sigiendo",
  "account.following_counter": "{count, plural, other {Sigiendo a {counter}}}",
  "account.follows.empty": "Este utilizador ainda no sige a dingun.",
  "account.follows_you": "Te sige",
  "account.go_to_profile": "Va al profil",
  "account.hide_reblogs": "Eskonde repartajasyones de @{name}",
  "account.in_memoriam": "De bendicha memoria.",
  "account.joined_short": "Adjunto",
  "account.languages": "Troka linguas abonadas",
  "account.link_verified_on": "La propriedad de este atadijo fue verifikada el {date}",
  "account.locked_info": "El estado de privasita de este konto esta konfigurado komo serado. El proprietario reviza manualmente kien le puede segir.",
  "account.media": "Multimedia",
  "account.mention": "Enmenta a @{name}",
  "account.moved_to": "{name} tiene endikado ke su muevo kuento agora es:",
  "account.mute": "Silensia a @{name}",
  "account.mute_notifications_short": "Silensia avizos",
  "account.mute_short": "Silensia",
  "account.muted": "Silensiado",
  "account.mutual": "Vos sigesh mutualmente",
  "account.no_bio": "No ay deskripsion.",
  "account.open_original_page": "Avre pajina orijnala",
  "account.posts": "Publikasyones",
  "account.report": "Raporta @{name}",
  "account.requested_follow": "{name} tiene solisitado segirte",
  "account.share": "Partaja el profil de @{name}",
  "account.show_reblogs": "Amostra repartajasyones de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publikasyon} other {{counter} publikasyones}}",
  "account.unblock": "Dezbloka a @{name}",
  "account.unblock_domain": "Dezbloka domeno {domain}",
  "account.unblock_domain_short": "Dezbloka",
  "account.unblock_short": "Dezbloka",
  "account.unendorse": "No avalia en profil",
  "account.unfollow": "Desige",
  "account.unmute": "Desilensia a @{name}",
  "account.unmute_notifications_short": "Desilensia avizos",
  "account.unmute_short": "Desilensia",
  "account_note.placeholder": "Klika para adjustar nota",
  "admin.dashboard.daily_retention": "Proporsyon de retensyon de utilizadores por diya dempues de enrejistrasyon",
  "admin.dashboard.monthly_retention": "Proporsyon de retensyon de utilizadores por mez dempues de enrejistrasyon",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mez de enrejistrasyon",
  "admin.dashboard.retention.cohort_size": "Muevos utilizadores",
  "admin.impact_report.instance_accounts": "Profiles de kuentos esto efasaria",
  "admin.impact_report.instance_followers": "Suivantes a los kualos nuestros utilizadores pedrerian",
  "admin.impact_report.instance_follows": "Suivantes a los kualos sus utilizadores pedrerian",
  "admin.impact_report.title": "Rezumen de impakto",
  "alert.rate_limited.message": "Por favor aprova dempues de {retry_time, time, medium}.",
  "alert.rate_limited.title": "Trafiko limitado",
  "alert.unexpected.message": "Afito un yerro no asperado.",
  "alert.unexpected.title": "Atyo!",
  "alt_text_badge.title": "Teksto alternativo",
  "alt_text_modal.add_alt_text": "Adjusta teksto alternativo",
  "alt_text_modal.add_text_from_image": "Adjusta teksto de imaje",
  "alt_text_modal.cancel": "Anula",
  "alt_text_modal.change_thumbnail": "Troka minyatura",
  "alt_text_modal.done": "Fecho",
  "announcement.announcement": "Pregon",
  "annual_report.summary.most_used_app.most_used_app": "la aplikasyon mas uzada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "la etiketa mas uzada",
  "annual_report.summary.new_posts.new_posts": "puvlikasyones muevas",
  "attachments_list.unprocessed": "(no prosesado)",
  "audio.hide": "Eskonde audio",
  "block_modal.show_less": "Amostra manko",
  "block_modal.show_more": "Amostra mas",
  "block_modal.they_will_know": "Puede ver ke esta blokado.",
  "block_modal.title": "Bloka utilizador?",
  "boost_modal.combo": "Puedes klikar {combo} para ometer esto la proksima vez",
  "boost_modal.reblog": "Repartajar puvlikasyon?",
  "boost_modal.undo_reblog": "Departajar puvlikasyon?",
  "bundle_column_error.copy_stacktrace": "Kopia el raporto de yerro",
  "bundle_column_error.error.body": "La pajina solisitada no pudo ser renderada. Podria ser por un yerro en muestro kodiche o un problem de kompatibilita kon el navigador.",
  "bundle_column_error.error.title": "Atyo, no!",
  "bundle_column_error.network.body": "Uvo un yerro kon la prova de eskargar esta pajina. Esto puede ser por un problem temporal kon tu koneksyon a la internet o a este sirvidor.",
  "bundle_column_error.network.title": "Yerro de red",
  "bundle_column_error.retry": "Aprova de muevo",
  "bundle_column_error.return": "Volta a la linya prinsipala",
  "bundle_column_error.routing.body": "No se pudo trokar la pajina solisitada. Estas siguro ke el adreso URL en la vara de adreso es djusto?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Serra",
  "bundle_modal_error.message": "Algo negro afito al eskargar este ekran.",
  "bundle_modal_error.retry": "Aprova de muevo",
  "closed_registrations.other_server_instructions": "Deke Mastodon es desentralizado, puedes kriyar un kuento en otro sirvidor i ainda enteraktuar kon este.",
  "closed_registrations_modal.description": "Aktualmente no es posivle kriyar un kuento en {domain}, ama por favor akodrate de ke no ay menester de tener un kuento espesifikamente en {domain} para kulanear Mastodon.",
  "closed_registrations_modal.find_another_server": "Bushka otro sirvidor",
  "closed_registrations_modal.preamble": "Mastodon es desentralizado, estonses sin emportansya ande kriyas tu kuento, podras segir i enteraktuar kon kualseker persona en este sirvidor. Tamyen puedes balabayarlo tu mezmo!",
  "closed_registrations_modal.title": "Enrerjistrate en Mastodon",
  "column.about": "Sovre mozotros",
  "column.blocks": "Utilizadores blokados",
  "column.bookmarks": "Markadores",
  "column.community": "Linya lokala",
  "column.create_list": "Kriya lista",
  "column.direct": "Enmentaduras privadas",
  "column.directory": "Eksplora profiles",
  "column.domain_blocks": "Domenos blokados",
  "column.edit_list": "Edita lista",
  "column.favourites": "Te plazen",
  "column.firehose": "Linyas en bivo",
  "column.firehose_singular": "Linya en bivo",
  "column.follow_requests": "Solisitudes de segimiento",
  "column.home": "Linya prinsipala",
  "column.lists": "Listas",
  "column.mutes": "Utilizadores silensiados",
  "column.notifications": "Avizos",
  "column.pins": "Publikasyones fiksadas",
  "column.public": "Linya federada",
  "column_back_button.label": "Atras",
  "column_header.hide_settings": "Eskonde opsyones",
  "column_header.moveLeft_settings": "Move kolumna a la siedra",
  "column_header.moveRight_settings": "Move kolumna a la derecha",
  "column_header.pin": "Fiksa",
  "column_header.show_settings": "Amostra opsyones",
  "column_header.unpin": "Defiksar",
  "column_search.cancel": "Anula",
  "community.column_settings.local_only": "Solo lokalas",
  "community.column_settings.media_only": "Solo multimedia",
  "community.column_settings.remote_only": "Solo remotas",
  "compose.language.change": "Troka lingua",
  "compose.language.search": "Bushka linguas...",
  "compose.published.body": "Publikasyon publikada.",
  "compose.published.open": "Avre",
  "compose.saved.body": "Publikasyon guadrada.",
  "compose_form.direct_message_warning_learn_more": "Ambezate mas",
  "compose_form.encryption_warning": "Publikasyones en Mastodon no son shifradas de lado a lado. No partajes dinguna enformasyon sensivle por Mastodon.",
  "compose_form.hashtag_warning": "Esta publikasyon no sera amostrada debasho de dinguna etiketa si no es publika. Solo publikasyones publikas se pueden bushkar por la etiketa.",
  "compose_form.lock_disclaimer": "Tu kuento no esta {locked}. Todos pueden segirte para ver tus publikasyones solo para suivantes.",
  "compose_form.lock_disclaimer.lock": "serrado",
  "compose_form.placeholder": "Ke haber?",
  "compose_form.poll.duration": "Durasion de anketa",
  "compose_form.poll.multiple": "Multiples opsyones",
  "compose_form.poll.option_placeholder": "Opsyon {number}",
  "compose_form.poll.single": "Opsyon unika",
  "compose_form.poll.switch_to_multiple": "Troka anketa para permeter a eskojer mas ke una opsyon",
  "compose_form.poll.switch_to_single": "Troka anketa para permeter a eskojer solo una opsyon",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Publika",
  "compose_form.reply": "Arisponde",
  "compose_form.save_changes": "Aktualiza",
  "compose_form.spoiler.marked": "Kita avertensya de kontenido",
  "compose_form.spoiler.unmarked": "Adjusta avertensya de kontenido",
  "compose_form.spoiler_placeholder": "Avertensya de kontenido (opsyonal)",
  "confirmation_modal.cancel": "Anula",
  "confirmations.block.confirm": "Bloka",
  "confirmations.delete.confirm": "Efasa",
  "confirmations.delete.message": "Estas siguro ke keres efasar esta publikasyon?",
  "confirmations.delete.title": "Efasar publikasyon?",
  "confirmations.delete_list.confirm": "Efasa",
  "confirmations.delete_list.message": "Estas siguro ke keres permanentemente efasar esta lista?",
  "confirmations.delete_list.title": "Efasa lista?",
  "confirmations.discard_draft.confirm": "Kita i kontinua",
  "confirmations.discard_edit_media.confirm": "Anula",
  "confirmations.discard_edit_media.message": "Tienes trokamientos no guadrados en la deskripsion o vista previa. Keres efasarlos entanto?",
  "confirmations.follow_to_list.title": "Segir utilizador?",
  "confirmations.logout.confirm": "Sal",
  "confirmations.logout.message": "Estas siguro ke keres salir de tu kuento?",
  "confirmations.logout.title": "Salir?",
  "confirmations.missing_alt_text.confirm": "Adjusta teksto alternativo",
  "confirmations.missing_alt_text.secondary": "Puvlika de todos modos",
  "confirmations.missing_alt_text.title": "Adjustar teksto alternativo?",
  "confirmations.mute.confirm": "Silensia",
  "confirmations.quiet_post_quote_info.got_it": "Entyendo",
  "confirmations.redraft.confirm": "Efasa i reeskrive",
  "confirmations.redraft.message": "Estas siguro ke keres efasar esta publikasyon i reeskrivirla? Pedreras todos los favoritos i repartajasyones asosiados kon esta publikasyon i repuestas a eya seran guerfanadas.",
  "confirmations.redraft.title": "Efasar i reeskrivir?",
  "confirmations.remove_from_followers.confirm": "Kita suivante",
  "confirmations.remove_from_followers.title": "Kitar suivante?",
  "confirmations.revoke_quote.confirm": "Kita puvlikasyon",
  "confirmations.revoke_quote.title": "Kitar puvlikasyon?",
  "confirmations.unblock.confirm": "Dezbloka",
  "confirmations.unblock.title": "Dezblokar a @{name}?",
  "confirmations.unfollow.confirm": "Desige",
  "confirmations.unfollow.title": "Desegir a @{name}?",
  "confirmations.withdraw_request.confirm": "Anula solisitud",
  "content_warning.hide": "Eskonde puvlikasyon",
  "content_warning.show": "Amostra entanto",
  "content_warning.show_more": "Amostra mas",
  "conversation.delete": "Efasa konversasyon",
  "conversation.mark_as_read": "Marka komo meldado",
  "conversation.open": "Ve konversasyon",
  "conversation.with": "Kon {names}",
  "copy_icon_button.copied": "Kopiado al portapapeles",
  "copypaste.copied": "Kopiado",
  "copypaste.copy_to_clipboard": "Kopia al portapapeles",
  "directory.federated": "Dizde el fediverso konesido",
  "directory.local": "Solo de {domain}",
  "directory.new_arrivals": "Arivados resientemente",
  "directory.recently_active": "Aktivos resientemente",
  "disabled_account_banner.account_settings": "Preferensyas de kuento",
  "disabled_account_banner.text": "Tu kuento {disabledAccount} esta aktualmente inkapasitado.",
  "dismissable_banner.community_timeline": "Estas son las publikasyones publikas mas resientes de las personas kualos kuentos estan balabayados en {domain}.",
  "dismissable_banner.dismiss": "Kita",
  "dismissable_banner.public_timeline": "Estas son las publikasyones publikas mas resientes de personas en el fediverso a las kualas la djente de {domain} sige.",
  "domain_block_modal.block": "Bloka sirvidor",
  "domain_block_modal.block_account_instead": "Bloka @{name} en su lugar",
  "domain_block_modal.they_can_interact_with_old_posts": "Las personas de este sirvidor pueden enteraktuar kon tus puvlikasyones viejas.",
  "domain_block_modal.they_cant_follow": "Dingun de este sirvidor puede segirte.",
  "domain_block_modal.they_wont_know": "No savra ke tiene sido blokado.",
  "domain_block_modal.title": "Bloka el domeno?",
  "domain_block_modal.you_wont_see_posts": "No veras publikasyones ni avizos de utilizadores en este sirvidor.",
  "domain_pill.server": "Sirvidor",
  "domain_pill.their_handle": "Su alias:",
  "domain_pill.username": "Nombre de utilizador",
  "domain_pill.whats_in_a_handle": "En ke konsiste el alias?",
  "domain_pill.your_handle": "Tu alias:",
  "dropdown.empty": "Eskoje una opsyon",
  "embed.instructions": "Enkrusta esta publikasyon en tu sitio internetiko kopiando este kodiche.",
  "embed.preview": "Paresera ansina:",
  "emoji_button.activity": "Aktivita",
  "emoji_button.clear": "Alimpia",
  "emoji_button.custom": "Personalizado",
  "emoji_button.flags": "Bandieras",
  "emoji_button.food": "Kumidas i beverajes",
  "emoji_button.label": "Adjusta emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Emojis no topados",
  "emoji_button.objects": "Objektos",
  "emoji_button.people": "Djente",
  "emoji_button.recent": "Uzados frekuentemente",
  "emoji_button.search": "Bushka...",
  "emoji_button.search_results": "Rizultados de bushkeda",
  "emoji_button.symbols": "Simbolos",
  "emoji_button.travel": "Viajes i lugares",
  "empty_column.account_hides_collections": "Este utilizador desidio no amostrar esta enformasyon",
  "empty_column.account_suspended": "Kuento suspendido",
  "empty_column.account_timeline": "No ay publikasyones aki!",
  "empty_column.account_unavailable": "Profil no desponivle",
  "empty_column.blocks": "Ainda no tienes blokado a dingun utilizador.",
  "empty_column.bookmarked_statuses": "Ainda no tienes dinguna publikasyon kon markador. Kuando adjustes un markador a una, se amostrara aki.",
  "empty_column.community": "La linya de tiempo lokala esta vaziya. Eskrive algo publikamente para ampesar la fiesta!",
  "empty_column.direct": "Ainda no tienes enmentaduras privadas. Kuando embies o risives una, se amostra aki.",
  "empty_column.domain_blocks": "Ainda no ay domenos blokados.",
  "empty_column.explore_statuses": "No ay dingunos trendes agora. Mira mas tadre!",
  "empty_column.favourited_statuses": "Ainda no tienes publikasyones favoritas. Kuando indikes ke una te plaze, se amostrara aki.",
  "empty_column.favourites": "Dingun no tiene indikado ke le plaze una de tus publikasyones. Kuando algun lo ayga, se amostrara aki.",
  "empty_column.follow_requests": "No tienes dinguna solisitud de suivante. Kuando risivas una, se amostrara aki.",
  "empty_column.followed_tags": "Ainda no tienes segido dinguna etiketa. Kuando lo aygas, se amostraran aki.",
  "empty_column.hashtag": "Ainda no ay niente en esta etiketa.",
  "empty_column.home": "Tu linya de tiempo esta vaziya! Sige a mas personas para inchirla.",
  "empty_column.list": "Ainda no ay niente en esta lista. Kuando miembros de esta lista publiken muevas publikasyones, se amostraran aki.",
  "empty_column.mutes": "Ainda no tienes silensiado a dingun utilizador.",
  "empty_column.notifications": "Ainda no tienes dingun avizo. Kuando otras personas enteraktuen kontigo, se amostraran aki.",
  "empty_column.public": "No ay niente aki! Eskrive algo publikamente o manualmente sige utilizadores de otros sirvidores para inchirlo",
  "error.unexpected_crash.explanation": "Por un yerro en muestro kodiche o un problem de kompatibilita kon el navigador, no se puede amostrar esta pajina djustamente.",
  "error.unexpected_crash.explanation_addons": "No se puede amostrar esta pajina djustamente. Este yerro probavlemente fue kauzado por un komplimento del navigador o por un enstrumento de traduksyon.",
  "error.unexpected_crash.next_steps": "Aprova arefreskar la pajina. Si esto no ayuda, es posivle ke ainda puedas kulaenar Mastodon kon otro navigador u otra aplikasyon nativa.",
  "error.unexpected_crash.next_steps_addons": "Aprova inkapasitarlos i arefreskar la pajina. Si esto no te ayuda, es posivle ke ainda puedas kulanear Mastodon kon otro navigador u otra aplikasyon nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Kopia stacktrace al portapapeles",
  "errors.unexpected_crash.report_issue": "Raporta problema",
  "explore.suggested_follows": "Djente",
  "explore.title": "En trend",
  "explore.trending_links": "Haberes",
  "explore.trending_statuses": "Publikasyones",
  "explore.trending_tags": "Etiketas",
  "filter_modal.added.context_mismatch_explanation": "Esta kategoria del filtro no se aplika al konteksto en ke tienes aksesido esta publikasyon. Si keres ke la publikasyon sea filtrada en este konteksto tamyen, kale editar el filtro.",
  "filter_modal.added.context_mismatch_title": "El konteksto no koensida!",
  "filter_modal.added.expired_explanation": "Esta kategoria de filtros tiene kadukado. Kale ke trokar la data de kadukasion para aplikarla.",
  "filter_modal.added.expired_title": "Filtro kadukado!",
  "filter_modal.added.review_and_configure": "Para revizar i konfigurar esta kategoria de filtros, va a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Konfigurasyon de filtro",
  "filter_modal.added.settings_link": "pajina de konfigurasyon",
  "filter_modal.added.short_explanation": "Esta publikasyon fue adjustada a la sigiente kategoria de filtros: {title}.",
  "filter_modal.added.title": "Filtro adjustado!",
  "filter_modal.select_filter.context_mismatch": "no se aplika a este konteksto",
  "filter_modal.select_filter.expired": "kadukado",
  "filter_modal.select_filter.prompt_new": "Mueva kategoria: {name}",
  "filter_modal.select_filter.search": "Bushka o kriya",
  "filter_modal.select_filter.subtitle": "Kulanea una kategoria egzistente o kriya mueva",
  "filter_modal.select_filter.title": "Filtra esta publikasyon",
  "filter_modal.title.status": "Filtra una publikasyon",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {dingun} one {una persona} other {# personas}} ke puedes koneser",
  "filtered_notifications_banner.title": "Avizos filtrados",
  "firehose.all": "Todo",
  "firehose.local": "Este sirvidor",
  "firehose.remote": "Otros sirvidores",
  "follow_request.authorize": "Autoriza",
  "follow_request.reject": "Refuza",
  "follow_requests.unlocked_explanation": "Aunke tu kuento no esta serrado, la taifa de {domain} kreye ke talvez keres revizar manualmente las solisitudes de segimento de estos kuentos.",
  "follow_suggestions.curated_suggestion": "Seleksyon de la taifa",
  "follow_suggestions.dismiss": "No amostra mas",
  "follow_suggestions.friends_of_friends_longer": "Popular entre personas a las kualas siges",
  "follow_suggestions.hints.featured": "Este profil tiene sido eskojido por la taifa de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este profil es popular entre las personas ke siges.",
  "follow_suggestions.hints.most_followed": "Este profil es uno de los mas segidos en {domain}.",
  "follow_suggestions.hints.most_interactions": "Este profil tiene resivido muncha atansion resientemente en {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este profil es similar a otros ke tienes segido resientemente.",
  "follow_suggestions.personalized_suggestion": "Sujestion personalizada",
  "follow_suggestions.popular_suggestion": "Sujestion populara",
  "follow_suggestions.popular_suggestion_longer": "Popular en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similares a los profils ke tienes segido resyentemente",
  "follow_suggestions.view_all": "Ve todos",
  "follow_suggestions.who_to_follow": "A ken segir",
  "followed_tags": "Etiketas segidas",
  "footer.about": "Sovre mozotros",
  "footer.about_this_server": "Sovre mozotros",
  "footer.directory": "Katalogo de profiles",
  "footer.get_app": "Abasha aplikasyon",
  "footer.keyboard_shortcuts": "Akortamientos de klaviatura",
  "footer.privacy_policy": "Politika de privasita",
  "footer.source_code": "Ve kodiche fuente",
  "footer.status": "Estado",
  "footer.terms_of_service": "Terminos de servisyo",
  "generic.saved": "Guadrado",
  "getting_started.heading": "Primos pasos",
  "hashtag.admin_moderation": "Avre la enterfaz de moderasyon para #{name}",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "Rekomendasyones no topadas",
  "hashtag.column_settings.select.placeholder": "Mete etiketas…",
  "hashtag.column_settings.tag_mode.all": "Todos estos",
  "hashtag.column_settings.tag_mode.any": "Kualsekera de estos",
  "hashtag.column_settings.tag_mode.none": "Dinguno de estos",
  "hashtag.column_settings.tag_toggle": "Inkluye etiketas adisionalas en esta kolumna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} partisipante} other {{counter} partisipantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publikasyon} other {{counter} publikasyones}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publikasyon} other {{counter} publikasyones}} oy",
  "hashtag.feature": "Avalia en profil",
  "hashtag.follow": "Sige etiketa",
  "hashtag.mute": "Silensia #{hashtag}",
  "hashtag.unfeature": "No avalia en profil",
  "hashtag.unfollow": "Desige etiketa",
  "hashtags.and_other": "…i {count, plural, one {}other {# mas}}",
  "hints.profiles.followers_may_be_missing": "Puede ser ke algunos suivantes de este profil no se amostren.",
  "hints.profiles.follows_may_be_missing": "Puede ser ke algunos kuentos segidos por este profil no se amostren.",
  "hints.profiles.posts_may_be_missing": "Puede ser ke algunas puvlikasyones de este profil no se amostren.",
  "hints.profiles.see_more_followers": "Ve mas suivantes en {domain}",
  "hints.profiles.see_more_follows": "Ve mas segidos en {domain}",
  "hints.profiles.see_more_posts": "Ve mas puvlikasyones en {domain}",
  "home.column_settings.show_quotes": "Muestra sitas",
  "home.column_settings.show_reblogs": "Amostra repartajasyones",
  "home.column_settings.show_replies": "Amostra repuestas",
  "home.hide_announcements": "Eskonde pregones",
  "home.pending_critical_update.body": "Por favor aktualiza tu sirvidor de Mastodon pishin!",
  "home.pending_critical_update.link": "Ve aktualizasyones",
  "home.pending_critical_update.title": "Aktualizasyon de seguridad kritika esta desponivle!",
  "home.show_announcements": "Amostra pregones",
  "ignore_notifications_modal.ignore": "Inyora avizos",
  "ignore_notifications_modal.limited_accounts_title": "Inyorar avizos de kuentos moderados?",
  "ignore_notifications_modal.new_accounts_title": "Inyorar avizos de kuentos muevos?",
  "ignore_notifications_modal.not_followers_title": "Inyorar avizos de personas a las kualas no te sigen?",
  "ignore_notifications_modal.not_following_title": "Inyorar avizos de personas a las kualas no siges?",
  "ignore_notifications_modal.private_mentions_title": "Ignorar avizos de mensyones privadas no solisitadas?",
  "info_button.label": "Ayuda",
  "interaction_modal.go": "Va",
  "interaction_modal.no_account_yet": "Ainda no tienes kuento?",
  "interaction_modal.on_another_server": "En otro sirvidor",
  "interaction_modal.on_this_server": "En este sirvidor",
  "interaction_modal.title": "Konektate para kontinuar",
  "interaction_modal.username_prompt": "Por enshemplo {example}",
  "intervals.full.days": "{number, plural, one {# diya} other {# diyas}}",
  "intervals.full.hours": "{number, plural, one {# ora} other {# oras}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "Volta atras",
  "keyboard_shortcuts.blocked": "Avre lista de utilizadores blokados",
  "keyboard_shortcuts.boost": "Repartaja publikasyon",
  "keyboard_shortcuts.column": "Enfoka en una kolumna",
  "keyboard_shortcuts.compose": "Enfoka en el area de eskrivir publikasyon",
  "keyboard_shortcuts.description": "Deskripsyon",
  "keyboard_shortcuts.down": "Move verso abasho en la lista",
  "keyboard_shortcuts.enter": "Avre publikasyon",
  "keyboard_shortcuts.favourite": "Endika ke te plaze una publikasyon",
  "keyboard_shortcuts.favourites": "Avre lista de favoritos",
  "keyboard_shortcuts.federated": "Avre linya federada",
  "keyboard_shortcuts.heading": "Akortamientos de klaviatura",
  "keyboard_shortcuts.home": "Avre linya prinsipala",
  "keyboard_shortcuts.hotkey": "Klave rapido",
  "keyboard_shortcuts.legend": "Amostra esta lejenda",
  "keyboard_shortcuts.local": "Avre linya lokala",
  "keyboard_shortcuts.mention": "Enmenta al autor",
  "keyboard_shortcuts.muted": "Avre lista de utilizadores silensiados",
  "keyboard_shortcuts.my_profile": "Avre tu profil",
  "keyboard_shortcuts.notifications": "Avre kolumna de avizos",
  "keyboard_shortcuts.open_media": "Avre multimedia",
  "keyboard_shortcuts.pinned": "Avre lista de publikasyones fiksadas",
  "keyboard_shortcuts.profile": "Avre profil del autor",
  "keyboard_shortcuts.quote": "Sita puvlikasyon",
  "keyboard_shortcuts.reply": "Arisponde a publikasyon",
  "keyboard_shortcuts.requests": "Avre lista de solisitudes de suivantes",
  "keyboard_shortcuts.search": "Enfoka en la vara de bushkeda",
  "keyboard_shortcuts.spoilers": "Amostra/eskonde el kampo de avertensya de kontenido (CW)",
  "keyboard_shortcuts.start": "Avre la kolumna \"para ampesar\"",
  "keyboard_shortcuts.toggle_hidden": "Amostra/eskonde teksto detras de avertensya de kontenido (CW)",
  "keyboard_shortcuts.toggle_sensitivity": "Amostra/eskonde multimedia",
  "keyboard_shortcuts.toot": "Eskrive mueva publikasyon",
  "keyboard_shortcuts.translate": "para trezladar una puvlikasyon",
  "keyboard_shortcuts.unfocus": "No enfoka en el area de eskrivir/bushkeda",
  "keyboard_shortcuts.up": "Move verso arriva en la lista",
  "learn_more_link.got_it": "Entyendo",
  "learn_more_link.learn_more": "Ambezate mas",
  "lightbox.close": "Serra",
  "lightbox.next": "Sigiente",
  "lightbox.previous": "Anterior",
  "limited_account_hint.action": "Amostra el profil entanto",
  "limited_account_hint.title": "Este profil fue eskondido por los moderadores de {domain}.",
  "link_preview.author": "Publikasyon de {name}",
  "link_preview.more_from_author": "Mas de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publikasyon} other {{counter} publikasyones}}",
  "lists.add_member": "Adjusta",
  "lists.add_to_list": "Adjusta a lista",
  "lists.create": "Kriya",
  "lists.create_list": "Kriya lista",
  "lists.delete": "Efasa lista",
  "lists.done": "Fecho",
  "lists.edit": "Edita lista",
  "lists.find_users_to_add": "Bushka utilizadores para adjustar",
  "lists.list_name": "Nombre de lista",
  "lists.new_list_name": "Nombre de mueva lista",
  "lists.no_lists_yet": "Ainda no ay listas.",
  "lists.no_members_yet": "Ainda no ay myembros.",
  "lists.no_results_found": "No se toparon rezultados.",
  "lists.remove_member": "Kita",
  "lists.replies_policy.followed": "Kualseker utilizador segido",
  "lists.replies_policy.list": "Miembros de la lista",
  "lists.replies_policy.none": "Dinguno",
  "lists.save": "Guadra",
  "lists.search": "Bushka",
  "load_pending": "{count, plural, one {# muevo elemento} other {# muevos elementos}}",
  "loading_indicator.label": "Eskargando…",
  "media_gallery.hide": "Eskonde",
  "moved_to_account_banner.text": "Tu kuento {disabledAccount} esta aktualmente inkapasitado porke transferates a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Eskonde de avizos",
  "mute_modal.hide_options": "Eskonde opsyones",
  "mute_modal.indefinite": "Asta ke desho de silensyarlo",
  "mute_modal.show_options": "Amostra opsyones",
  "mute_modal.they_wont_know": "No savra ke tiene sido silensyado.",
  "mute_modal.title": "Silensiar utilizador?",
  "mute_modal.you_wont_see_mentions": "No veras publikasyones ke lo enmentan.",
  "navigation_bar.about": "Sovre mozotros",
  "navigation_bar.administration": "Administrasyon",
  "navigation_bar.advanced_interface": "Avre en la enterfaz avanzada",
  "navigation_bar.automated_deletion": "Efasasyon otomatika de publikasyones",
  "navigation_bar.blocks": "Utilizadores blokados",
  "navigation_bar.bookmarks": "Markadores",
  "navigation_bar.direct": "Enmentaduras privadas",
  "navigation_bar.domain_blocks": "Domenos blokados",
  "navigation_bar.favourites": "Te plazen",
  "navigation_bar.filters": "Biervos silensiados",
  "navigation_bar.follow_requests": "Solisitudes de segimiento",
  "navigation_bar.followed_tags": "Etiketas segidas",
  "navigation_bar.follows_and_followers": "Segidos i suivantes",
  "navigation_bar.import_export": "Importo i eksporto",
  "navigation_bar.lists": "Listas",
  "navigation_bar.logout": "Salir",
  "navigation_bar.moderation": "Moderasyon",
  "navigation_bar.more": "Mas",
  "navigation_bar.mutes": "Utilizadores silensiados",
  "navigation_bar.opened_in_classic_interface": "Publikasyones, kuentos i otras pajinas espesifikas se avren kon preferensyas predeterminadas en la enterfaz web klasika.",
  "navigation_bar.preferences": "Preferensyas",
  "navigation_bar.privacy_and_reach": "Privasita i alkanse",
  "navigation_bar.search": "Bushka",
  "navigation_bar.search_trends": "Bushka / Trendes",
  "navigation_panel.expand_lists": "Espande menu de lista",
  "not_signed_in_indicator.not_signed_in": "Nesesitas konektarse kon tu kuento para akseder este rekurso.",
  "notification.admin.report": "{name} raporto {target}",
  "notification.admin.report_statuses": "{name} raporto {target} por {category}",
  "notification.admin.report_statuses_other": "{name} raporto {target}",
  "notification.admin.sign_up": "{name} kriyo un konto",
  "notification.annual_report.view": "Ve #Wrapstodon",
  "notification.favourite": "A {name} le plaze tu publikasyon",
  "notification.follow": "{name} te ampeso a segir",
  "notification.follow_request": "{name} tiene solisitado segirte",
  "notification.label.mention": "Enmenta",
  "notification.label.private_mention": "Enmentadura privada",
  "notification.label.private_reply": "Repuesta privada",
  "notification.label.quote": "{name} sito tu publikasyon",
  "notification.label.reply": "Arisponde",
  "notification.mention": "Enmenta",
  "notification.mentioned_you": "{name} te enmento",
  "notification.moderation-warning.learn_more": "Ambezate mas",
  "notification.moderation_warning.action_disable": "Tu kuento tiene sido inkapasitado.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Algunas de tus publikasyones tienen sido markadas komo sensivles.",
  "notification.moderation_warning.action_sensitive": "Tus publikasyones seran markadas komo sensivles dizde agora.",
  "notification.moderation_warning.action_silence": "Tu kuento tiene sido limitado.",
  "notification.moderation_warning.action_suspend": "Tu kuento tiene sido suspendido.",
  "notification.own_poll": "Tu anketa eskapo",
  "notification.poll": "Anketa en ke votates eskapo",
  "notification.reblog": "{name} repartajo tu publikasyon",
  "notification.relationships_severance_event": "Koneksyones pedridas kon {name}",
  "notification.relationships_severance_event.learn_more": "Ambezate mas",
  "notification.status": "{name} publiko algo",
  "notification.update": "{name} edito una publikasyon",
  "notification_requests.accept": "Acheta",
  "notification_requests.dismiss": "Kita",
  "notification_requests.edit_selection": "Edita",
  "notification_requests.exit_selection": "Fecho",
  "notification_requests.maximize": "Maksimizar",
  "notification_requests.notifications_from": "Avizos de {name}",
  "notification_requests.title": "Avizos filtrados",
  "notification_requests.view": "Amostra avizos",
  "notifications.clear": "Efasa avizos",
  "notifications.clear_confirmation": "Estas siguro ke keres permanentemente efasar todos tus avizos?",
  "notifications.clear_title": "Efasar avizos?",
  "notifications.column_settings.admin.report": "Muveos raportos:",
  "notifications.column_settings.admin.sign_up": "Muevas enrejistrasyones:",
  "notifications.column_settings.alert": "Avizos de ensimameza",
  "notifications.column_settings.favourite": "Te plazen:",
  "notifications.column_settings.filter_bar.advanced": "Amostra todas las kategorias",
  "notifications.column_settings.filter_bar.category": "Vara de filtrado rapido",
  "notifications.column_settings.follow": "Muevos suivantes:",
  "notifications.column_settings.follow_request": "Muevas solisitudes de segimiento:",
  "notifications.column_settings.group": "Grupo",
  "notifications.column_settings.mention": "Enmentaduras:",
  "notifications.column_settings.poll": "Rizultados de anketas:",
  "notifications.column_settings.push": "Avizos arrepushados",
  "notifications.column_settings.quote": "Sitas:",
  "notifications.column_settings.reblog": "Repartajasyones:",
  "notifications.column_settings.show": "Amostra en kolumna",
  "notifications.column_settings.sound": "Reproduse son",
  "notifications.column_settings.status": "Publikasyones muevas:",
  "notifications.column_settings.unread_notifications.category": "Avizos no meldados",
  "notifications.column_settings.unread_notifications.highlight": "Avalia avizos no meldados",
  "notifications.column_settings.update": "Edisyones:",
  "notifications.filter.all": "Todos",
  "notifications.filter.boosts": "Repartajasyones",
  "notifications.filter.favourites": "Te plazen",
  "notifications.filter.follows": "Segidos",
  "notifications.filter.mentions": "Enmentaduras",
  "notifications.filter.polls": "Rizultados de anketa",
  "notifications.filter.statuses": "Aktualizasyones de personas a las kualas siges",
  "notifications.grant_permission": "Da permiso.",
  "notifications.group": "{count} avizos",
  "notifications.mark_as_read": "Marka todos avizos komo meldados",
  "notifications.permission_denied": "Avizos de ensimameza no estan desponivles porke ya se tiene refuzado el permiso",
  "notifications.permission_denied_alert": "\"No se pueden kapasitar los avizos de ensimameza, porke ya se tiene refuzado el permiso de navigador",
  "notifications.permission_required": "Avizos de ensimameza no estan desponivles porke los nesesarios permisos no tienen sido risividos.",
  "notifications.policy.accept": "Acheta",
  "notifications.policy.accept_hint": "Amostra en avizos",
  "notifications.policy.drop": "Inyora",
  "notifications.policy.filter": "Filtra",
  "notifications.policy.filter_limited_accounts_hint": "Limitadas por moderadores del sirvidor",
  "notifications.policy.filter_limited_accounts_title": "Kuentos moderados",
  "notifications.policy.filter_new_accounts.hint": "Kriyadas durante {days, plural, one {el ultimo diya} other {los ultimos # diyas}}",
  "notifications.policy.filter_new_accounts_title": "Muevos kuentos",
  "notifications.policy.filter_not_followers_title": "Personas ke te no sigen",
  "notifications.policy.filter_not_following_hint": "Asta ke las aproves manualmente",
  "notifications.policy.filter_not_following_title": "Personas ke no siges",
  "notifications.policy.filter_private_mentions_title": "Enmentaduras privadas no solisitadas",
  "notifications_permission_banner.enable": "Kapasita avizos de ensimameza",
  "notifications_permission_banner.how_to_control": "Para risivir avizos kuando Mastodon no esta avierto, kapasita avizos de ensimameza. Puedes kontrolar presizamente kualos tipos de enteraksiones djeneren avizos de ensimameza kon el boton {icon} arriva kuando esten kapasitadas.",
  "notifications_permission_banner.title": "Nunkua te piedres niente",
  "onboarding.follows.back": "Atras",
  "onboarding.follows.empty": "Malorozamente, no se pueden amostrar rezultados en este momento. Puedes aprovar uzar la bushkeda o navigar por la pajina de eksplorasyon para topar personas a las que segir, o aprovarlo de muevo mas tadre.",
  "onboarding.follows.search": "Bushka",
  "onboarding.follows.title": "Sige personas para ampezar",
  "onboarding.profile.discoverable": "Faz ke mi profil apareska en bushkedas",
  "onboarding.profile.discoverable_hint": "Kuando permites ke tu profil sea diskuvriravle en Mastodon, tus publikasyones podran apareser en rezultados de bushkedas i trendes i tu profil podra ser sujerido a personas kon intereses similares a los tuyos.",
  "onboarding.profile.display_name": "Nombre amostrado",
  "onboarding.profile.display_name_hint": "Tu nombre para amostrar.",
  "onboarding.profile.note": "Tu deskripsyon",
  "onboarding.profile.note_hint": "Puedes @enmentar a otra djente o #etiketas…",
  "onboarding.profile.title": "Konfigurasyon de profil",
  "onboarding.profile.upload_avatar": "Karga imaje de profil",
  "onboarding.profile.upload_header": "Karga kavesera de profil",
  "password_confirmation.exceeds_maxlength": "La konfirmasyon de kod es demaziado lunga",
  "password_confirmation.mismatching": "Los dos kodes son desferentes",
  "picture_in_picture.restore": "Restora",
  "poll.closed": "Serrado",
  "poll.refresh": "Arefreska",
  "poll.reveal": "Mira los rezultados",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Vota",
  "poll.voted": "Votates por esta repuesta",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Adjusta anketa",
  "poll_button.remove_poll": "Kita anketa",
  "privacy.change": "Troka privasita de publikasyon",
  "privacy.direct.long": "Todos enmentados en la publikasyon",
  "privacy.direct.short": "Enmentadura privada",
  "privacy.private.long": "Solo para tus suivantes",
  "privacy.private.short": "Suivantes",
  "privacy.public.long": "Todos en i afuera de Mastodon",
  "privacy.public.short": "Publiko",
  "privacy.unlisted.additional": "Esto funksyona exaktamente komo publiko, eksepto ke la publikasyon no aparesera en linyas publikas o etiketas, la eksplorasyon o bushkedas de Mastodon, inkluzo si kapasites esto para tu kuento.",
  "privacy.unlisted.short": "Publiko i silensyozo",
  "privacy_policy.last_updated": "Ultima aktualizasyon: {date}",
  "privacy_policy.title": "Politika de privasita",
  "recommended": "Rekomendado",
  "refresh": "Arefreska",
  "regeneration_indicator.please_stand_by": "Aspera por favor.",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "antes {number, plural, one {# diya} other {# diyas}}",
  "relative_time.full.hours": "antes {number, plural, one {# ora} other {# oras}}",
  "relative_time.full.just_now": "agora",
  "relative_time.full.minutes": "antes {number, plural, one {# minuto} other {# minutos}}",
  "relative_time.full.seconds": "antes {number, plural, one {# sigundo} other {# sigundos}}",
  "relative_time.hours": "{number} o",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "oy",
  "remove_quote_hint.button_label": "Entyendo",
  "reply_indicator.attachments": "{count, plural, one {# anekso} other {# aneksos}}",
  "reply_indicator.cancel": "Anula",
  "reply_indicator.poll": "Anketa",
  "report.block": "Bloka",
  "report.block_explanation": "No veras sus publikasyones. No podra ver tus publikasyones ni segirte. Podra saver ke le blokates.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Otros",
  "report.categories.spam": "Spam",
  "report.categories.violation": "El kontenido viola una o mas reglas del sirvidor",
  "report.category.subtitle": "Eskoje la mijor koensidensya",
  "report.category.title": "Deskrive el problem kon {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "publikasyon",
  "report.close": "Fecho",
  "report.comment.title": "Ay algo mas ke deveriamos saver?",
  "report.forward": "Reembia a {target}",
  "report.forward_hint": "Este kuento es de otro sirvidor. Embiar una kopia anonimizada del raporto ayi tamyen?",
  "report.mute": "Silensia",
  "report.mute_explanation": "No veras sus publikasyones. Ainda pueden segirte i no va saver ke le silensiates.",
  "report.next": "Sigiente",
  "report.placeholder": "Otros komentos",
  "report.reasons.dislike": "No me plaze",
  "report.reasons.dislike_description": "\"No es algo ke kero ver",
  "report.reasons.legal": "Es ilegal",
  "report.reasons.legal_description": "Kreyes ke esta violando la ley de tu paiz o el paiz del sirvidor",
  "report.reasons.other": "Es otra koza",
  "report.reasons.other_description": "El problem no es de las otras kategorias",
  "report.reasons.spam": "Es spam",
  "report.reasons.spam_description": "Atadijos malisiozos, enteraksyones falsas o repuestas repetitivas",
  "report.reasons.violation": "Viola las reglas del sirvidor",
  "report.reasons.violation_description": "Saves ke viola reglas espesifikas",
  "report.rules.subtitle": "Eskoje todas ke korespondan",
  "report.rules.title": "Kualas reglas estan violadas?",
  "report.statuses.subtitle": "Eskoje todas ke korespondan",
  "report.statuses.title": "Ay alguna publikasyon ke suporta este raporto?",
  "report.submit": "Embia",
  "report.target": "Raportando a {target}",
  "report.thanks.take_action": "Aki estan tus opsyones para kontrolar lo ke ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mientres revizamos esto, puedes tomar aksyones kontra @{name}:",
  "report.thanks.title": "No keres ver esto?",
  "report.thanks.title_actionable": "Mersi por raportarlo, vamos revizarlo.",
  "report.unfollow": "Desige a @{name}",
  "report.unfollow_explanation": "Estas sigiendo este kuento. Para no ver sus publikasyones en tu linya de tiempo, puedes deshar de segirlo.",
  "report_notification.attached_statuses": "{count, plural, one {{count} publikasyon} other {{count} publikasyones}} atadas",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "kontenido ilegal",
  "report_notification.categories.other": "Otros",
  "report_notification.categories.other_sentence": "otros",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Violasyon de reglas",
  "report_notification.categories.violation_sentence": "violasyon de reglas",
  "report_notification.open": "Avre raporto",
  "search.no_recent_searches": "No ay bushkedas resientes",
  "search.placeholder": "Bushka",
  "search.quick_action.account_search": "Profiles ke koresponden kon {x}",
  "search.quick_action.go_to_account": "Va al profil {x}",
  "search.quick_action.go_to_hashtag": "Va a la etiketa {x}",
  "search.quick_action.open_url": "Avre URL en Mastodon",
  "search.quick_action.status_search": "Publikasyones ke koresponden kon {x}",
  "search.search_or_paste": "Bushka o apega URL",
  "search_popout.full_text_search_disabled_message": "No desponivle en {domain}.",
  "search_popout.full_text_search_logged_out_message": "Solo desponivle kuando estas konektado kon tu kuento.",
  "search_popout.language_code": "kodiche ISO de lingua",
  "search_popout.options": "Opsyones de bushkeda",
  "search_popout.quick_actions": "Aksyones rapidas",
  "search_popout.recent": "Bushkedas resientes",
  "search_popout.specific_date": "dato espesifiko",
  "search_popout.user": "utilizador",
  "search_results.accounts": "Profiles",
  "search_results.all": "Todos",
  "search_results.hashtags": "Etiketas",
  "search_results.no_results": "No ay rezultados.",
  "search_results.see_all": "Ve todo",
  "search_results.statuses": "Publikasyones",
  "search_results.title": "Bushka por \"{q}\"",
  "server_banner.about_active_users": "Utilizadores aktivos en este sirvidor durante los ultimos 30 diyas (utilizadores aktivos mensuales)",
  "server_banner.active_users": "utilizadores aktivos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.server_stats": "Estatistikas del sirvidor:",
  "sign_in_banner.create_account": "Kriya kuento",
  "sign_in_banner.sign_in": "Konektate",
  "sign_in_banner.sso_redirect": "Konektate o enrejistrate",
  "status.admin_account": "Avre la enterfaz de moderasyon para @{name}",
  "status.admin_domain": "Avre la enterfaz de moderasyon para @{domain}",
  "status.admin_status": "Avre esto en la enterfaz de moderasyon",
  "status.block": "Bloka a @{name}",
  "status.bookmark": "Marka",
  "status.cancel_reblog_private": "No repartaja",
  "status.cannot_reblog": "Esta publikasyon no se puede repartajar",
  "status.contains_quote": "Kontriene sita",
  "status.context.loading": "Kargando mas repuestas",
  "status.context.loading_error": "No se pudieron kargar repuestas muevas",
  "status.context.loading_success": "Muevas repuestas kargadas",
  "status.context.more_replies_found": "Se toparon mas repuestas",
  "status.context.retry": "Reprova",
  "status.context.show": "Amostra",
  "status.continued_thread": "Kontinuasion del filo",
  "status.copy": "Kopia atadijo de publikasyon",
  "status.delete": "Efasa",
  "status.delete.success": "Puvlikasyon kitada",
  "status.detailed_status": "Vista de konversasyon detalyada",
  "status.direct": "Enmenta a @{name} en privado",
  "status.direct_indicator": "Enmentadura privada",
  "status.edit": "Edita",
  "status.edited": "Ultima edisyon: {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} vez} other {{count} vezes}}",
  "status.embed": "Obtiene kodiche para enkrustar",
  "status.favourite": "Te plaze",
  "status.filter": "Filtra esta publikasyon",
  "status.history.created": "{name} kriyo {date}",
  "status.history.edited": "{name} edito {date}",
  "status.load_more": "Eskarga mas",
  "status.media.open": "Klika para avrir",
  "status.media.show": "Klika para amostrar",
  "status.media_hidden": "Multimedia eskondidos",
  "status.mention": "Enmenta a @{name}",
  "status.more": "Mas",
  "status.mute": "Silensia a @{name}",
  "status.mute_conversation": "Silensia konversasyon",
  "status.open": "Espande publikasyon",
  "status.pin": "Fiksa en profil",
  "status.quote": "Sita",
  "status.quote.cancel": "Anula la sita",
  "status.quote_error.limited_account_hint.action": "Amostra entanto",
  "status.quote_error.limited_account_hint.title": "Este kuento fue eskondido por los moderadores de {domain}.",
  "status.quote_error.not_available": "Puvlikasyon no desponivle",
  "status.quote_error.pending_approval": "Puvlikasyon esta asperando",
  "status.quote_error.revoked": "Puvlikasyon kitada por el otor",
  "status.quote_followers_only": "Solo los suivantes pueden sitar esta puvlikasyon",
  "status.quote_noun": "Sita",
  "status.quote_policy_change": "Troka ken puede sitar",
  "status.quote_post_author": "Sito una puvlikasyon de @{name}",
  "status.quote_private": "No se puede sitar puvlikasyones privadas",
  "status.read_more": "Melda mas",
  "status.reblog": "Repartaja",
  "status.reblog_or_quote": "Repartaja o partaja",
  "status.reblogged_by": "{name} repartajo",
  "status.reblogs.empty": "Ainda nadie tiene repartajado esta publikasyon. Kuando algien lo aga, se amostrara aki.",
  "status.redraft": "Efasa i eskrive de muevo",
  "status.remove_bookmark": "Kita markador",
  "status.remove_favourite": "Kita de los favoritos",
  "status.remove_quote": "Kita",
  "status.replied_in_thread": "Arispondo en filo",
  "status.replied_to": "Arispondio a {name}",
  "status.reply": "Arisponde",
  "status.replyAll": "Arisponde al filo",
  "status.report": "Raporta @{name}",
  "status.request_quote": "Solisita sitasyon",
  "status.sensitive_warning": "Kontenido sensivle",
  "status.share": "Partaja",
  "status.show_less_all": "Amostra manko para todo",
  "status.show_more_all": "Amostra mas para todo",
  "status.show_original": "Amostra orijinal",
  "status.title.with_attachments": "{user} publiko {attachmentCount, plural, one {un anekso} other {{attachmentCount} aneksos}}",
  "status.translate": "Trezlada",
  "status.translated_from_with": "Trezladado dizde {lang} kon {provider}",
  "status.uncached_media_warning": "Vista previa no desponivle",
  "status.unmute_conversation": "Desilensia konversasyon",
  "status.unpin": "Defiksar del profil",
  "subscribed_languages.lead": "Solo publikasyones en linguas eskojidas se amostraran en tus linya de tiempo prinsipala i listas dempues del trokamiento. Eskoje dinguna para risivir publikasyones en todas las linguas.",
  "subscribed_languages.save": "Guadra trokamientos",
  "subscribed_languages.target": "Troka linguas abonadas para {target}",
  "tabs_bar.home": "Linya prinsipala",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Avizos",
  "tabs_bar.publish": "Mueva publikasyon",
  "tabs_bar.search": "Bushkeda",
  "terms_of_service.title": "Terminos de servisyo",
  "time_remaining.days": "{number, plural, one {# diya restante} other {# diyas restantes}}",
  "time_remaining.hours": "{number, plural, one {# ora restante} other {# oras restantes}}",
  "time_remaining.minutes": "{number, plural, one {# minuto restante} other {# minutos restantes}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{number, plural, one {# sigundo restante} other {# sigundos restantes}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} kuento} other {{counter} kuentos}} en los ultimos {days, plural, one {diyas} other {{days} diyas}}",
  "trends.trending_now": "Trendes",
  "ui.beforeunload": "La publikasyon ke estas eskriviendo se pedrera si sales de Mastodon.",
  "units.short.billion": "{count} MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} K",
  "upload_area.title": "Arastra i mete para kargar",
  "upload_button.label": "Adjusta imajes, un video or una dosya audio",
  "upload_error.limit": "Limito de dosyas kargadas eksedido.",
  "upload_error.poll": "No se permite kargar dosyas kon anketas.",
  "upload_form.edit": "Edita",
  "upload_progress.label": "Kargando...",
  "upload_progress.processing": "Prosesando…",
  "username.taken": "Akel nombre de utilizador ya esta en uzo. Aprova otruno",
  "video.close": "Serra video",
  "video.download": "Abasha dosya",
  "video.exit_fullscreen": "Sal de ekran kompleto",
  "video.expand": "Espande video",
  "video.fullscreen": "Ekran kompleto",
  "video.hide": "Eskonde video",
  "video.mute": "Silensia",
  "video.pause": "Pauza",
  "video.play": "Reproduze",
  "video.unmute": "Desilensia",
  "visibility_modal.button_title": "Konfigura la vizibilita",
  "visibility_modal.header": "Vizibilita i enteraksyon",
  "visibility_modal.privacy_label": "Vizivilita",
  "visibility_modal.quote_followers": "Solo suivantes",
  "visibility_modal.quote_label": "Ken puede sitar",
  "visibility_modal.quote_nobody": "Solo yo",
  "visibility_modal.quote_public": "Todos",
  "visibility_modal.save": "Guadra"
}
